<footer class="container-fluid">
	<div class="row main-footer-row top-row">
		<div class="col-12 col-lg-3 col-xxl-4 mb-4 mb-lg-0">
			<p class="mb-5"><img src="//assets.powerkiosk.com/web/images/pk-logo-horiz-allWhite.svg" alt="Power Kiosk" class="footer-logo" /></p>
		</div>
		<div class="col-12 col-lg-5 offset-xl-1 offset-xxl-0">
			<h3 class="mb-5 tagline">One platform with tools and insights to <br class="d-none d-lg-block" />help you achieve your energy goals.</h3>
		</div>
		<div class="col-12 col-lg-3">
			<p>
				<a [href]="scheduleDemoHref" class="btn btn-primary schedule-demo" id="scheduleDemoFooter"
					>Schedule Discovery Call <span class="ending-icon"><fa-icon [icon]="['fas', 'arrow-right']"></fa-icon></span
				></a>
			</p>
		</div>
	</div>
	<div class="row main-footer-row middle-row">
		<div class="col-12 col-xl-4 mb-5 mb-xl-0">
			<div class="row">
				<div class="col mb-3">
					<h4>Our Accreditations</h4>
				</div>
			</div>
			<div class="row mb-5 mb-xl-0">
				<div class="col-auto">
					<a href="https://www.inc.com/profile/nrg-kiosk" target="_blank">
						<img src="//assets.powerkiosk.com/web/images/inc-5000-white.svg" alt="Inc 5000" class="footer-accreditation" />
					</a>
				</div>
				<div class="col-auto">
					<a href="https://www.tepausa.org/" target="_blank">
						<img src="//assets.powerkiosk.com/web/images/tepa-white.svg" alt="The Energy Professionals Association" class="footer-accreditation" />
					</a>
				</div>
				<div class="col-auto">
					<a href="https://www.bbb.org/us/il/chicago/profile/energy-service-company/power-kiosk-0654-88654170/#sealclick" target="_blank">
						<img src="//assets.powerkiosk.com/web/images/bbb-white.svg" alt="Better Business Bureau" class="footer-accreditation" />
					</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-xl-8">
			<div class="row">
				<div class="col-12 col-sm-6 col-md-3 col-xl-auto col-xxl-3 mb-4 mb-lg-0">
					<h4 class="mb-4">
						<a class="footer-link" [routerLink]="['/why-power-kiosk']" id="footerWhyPK">Why Power Kiosk</a>
					</h4>
					<h4 class="mb-3">Who We Serve</h4>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/partners', 'energy-advisor']" id="footerWhyPK">Energy Advisor</a></p>
					<p class="mb-2">
						<a class="footer-link" [routerLink]="['/partners', 'commercial-and-enterprise']" id="footerCommercialAndEnterprise"
							>Commercial &amp; Enterprise</a
						>
					</p>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/partners', 'referral-partner']" id="footerReferralPartner">Referral Partner</a></p>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/partners', 'energy-supplier']" id="footerEnergySupplier">Energy Supplier</a></p>
				</div>
				<div class="col-12 col-sm-6 col-md-3 col-xl-auto col-xxl-3 mb-4 mb-lg-0">
					<h4 class="mb-3">Products</h4>
					<p class="mb-2">
						<a class="footer-link" [routerLink]="['/products']" [fragment]="'energy-marketplace'" id="footerEnergyMarketplace">Energy Marketplace</a>
					</p>
					<p class="mb-2">
						<a class="footer-link" [routerLink]="['/products']" [fragment]="'energy-portals'" id="footerEnergyPortals">Energy Portals</a>
					</p>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/products']" [fragment]="'ai-agents'" id="footerAIAgents">AI Agents</a></p>
					<p class="mb-2">
						<a class="footer-link" [routerLink]="['/products']" [fragment]="'industry-training'" id="footerIndustryTraining">Industry Training</a>
					</p>
				</div>
				<div class="col-12 col-sm-6 col-md-3 col-xl-auto col-xxl-3 mb-4 mb-md-0">
					<h4 class="mb-3">Resources</h4>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/resources', 'advisor-academy']" id="footerAdvisorAcademy">Advisor Academy</a></p>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/resources', 'blog']" id="footerBlog">Blog</a></p>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/resources', 'customer-stories']" id="footerCustomerStories">Customer Stories</a></p>
					<p class="mb-2">
						<a class="footer-link" [routerLink]="['/resources', 'deregulated-energy-map']" id="footerDeregulatedEnergyMap">Deregulated Energy Map</a>
					</p>
				</div>
				<div class="col-12 col-sm-6 col-md-3 col-xl-auto col-xxl-3">
					<h4 class="mb-3">Company</h4>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/company', 'about']" id="footerAbout">About</a></p>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/company', 'careers']" id="footerCareers">Careers</a></p>
					<p class="mb-2"><a class="footer-link" [routerLink]="['/company', 'contact-us']" id="footerContactUs">Contact Us</a></p>
				</div>
			</div>
		</div>
	</div>
	<div class="row footer-bottom-row">
		<div class="col-auto">
			<p>&copy;{{ year }} Power Kiosk</p>
		</div>
		<div class="col col-sm-auto">
			<p>
				<a [routerLink]="['/privacy-policy']" id="footerPrivacyPolicy" class="footer-bottom-link">Privacy Policy</a>
			</p>
		</div>
		<div class="col-12 col-sm">
			<p class="text-sm-end">
				<a href="https://www.linkedin.com/company/power-kiosk/" class="footer-linkedin" target="_blank"
					><img src="//assets.powerkiosk.com/web/images/linkedin-icon.svg" alt="LinkedIn" class="footer-linkedin-icon" /> LinkedIn</a
				>
			</p>
		</div>
	</div>
</footer>
